import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

export const queryClient = new QueryClient();

export function ReactQueryClientProvider(props: React.PropsWithChildren<{}>) {
	return <QueryClientProvider client={queryClient} children={props.children} />;
}
